import { InjectionToken } from '@angular/core';
import { SmsRegistrationDependencies, SmsContext } from './interface';

export const SmsInjectionToken = new InjectionToken<SmsRegistrationDependencies>(
  'dependencies for the sms registration',
);

export const SmsContextToken = new InjectionToken<SmsContext>('context for services in the sms lib');

export const SmsTextLimitToken = new InjectionToken<number>('limits the allowable size of SMS text');
